import React from 'react';

const AssignTaskPriorityCategory = React.lazy(() => import('pages/AssignTaskPriority/AssignTaskPriorityCategory'));
const AssignTaskPriorityCategoryAdd = React.lazy(
  () => import('pages/AssignTaskPriority/AssignTaskPriorityCategoryAdd'),
);
const AssignTaskPriorityCategoryEdit = React.lazy(
  () => import('pages/AssignTaskPriority/AssignTaskPriorityCategoryEdit'),
);
const AssignTaskPriorityCategoryDetail = React.lazy(
  () => import('pages/AssignTaskPriority/AssignTaskPriorityCategoryDetail'),
);

const assignTaskPriorityRoutes = [
  {
    path: '/assign-task-priority-category',
    exact: true,
    name: 'Danh sách mức độ ưu tiên',
    function: 'ASSIGN_TASK_PRIORITY_VIEW',
    component: AssignTaskPriorityCategory,
  },
  {
    path: '/assign-task-priority-category/add',
    exact: true,
    name: 'Thêm mới mức độ ưu tiên',
    function: 'ASSIGN_TASK_PRIORITY_ADD',
    component: AssignTaskPriorityCategoryAdd,
  },
  {
    path: '/assign-task-priority-category/detail/:id',
    exact: true,
    name: 'Chi tiết mức độ ưu tiên',
    function: 'ASSIGN_TASK_PRIORITY_VIEW',
    component: AssignTaskPriorityCategoryDetail,
  },
  {
    path: '/assign-task-priority-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa mức độ ưu tiên',
    function: 'ASSIGN_TASK_PRIORITY_EDIT',
    component: AssignTaskPriorityCategoryEdit,
  },
];

export default assignTaskPriorityRoutes;
